"use client";

import Image from "next/image";
import { useState } from "react";

interface Props {
  src: string;
  alt: string;
  initials: string;
  color: string;
}

export default function TeamAvatar({ src, alt, initials, color }: Props) {
  const [failed, setFailed] = useState(false);

  if (failed) {
    return (
      <div
        className="flex h-16 w-16 items-center justify-center rounded-2xl text-[18px] font-bold text-white"
        style={{ backgroundColor: color }}
      >
        {initials}
      </div>
    );
  }

  return (
    <div className="h-16 w-16 overflow-hidden rounded-2xl" style={{ backgroundColor: color }}>
      <Image
        src={src}
        alt={alt}
        width={64}
        height={64}
        className="h-full w-full object-cover object-top"
        onError={() => setFailed(true)}
      />
    </div>
  );
}
